import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { SyncOptionRadioGroup } from "./fields/SyncOptionRadioGroup";

export const BuildiumCredentialForm = ({ register }: CredentialFormProps) => {
  const syncField = register("buildium_sync");

  return (
    <>
      <BaseInput
        id="buildium_client_id"
        label="Client ID"
        {...register("buildium_client_id")}
        required
      />
      <BaseInput
        id="buildium_client_secret"
        label="Client secret"
        {...register("buildium_client_secret")}
        required
      />
      <BaseInput
        id="buildium_email"
        label="Email"
        {...register("buildium_email")}
      />
      <BaseInput
        id="buildium_password"
        label="Password"
        {...register("buildium_password")}
      />
      <BaseInput
        id="buildium_subdomain"
        label="Subdomain"
        {...register("buildium_subdomain")}
      />
      <SyncOptionRadioGroup
        field={syncField}
        prose={
          <>
            Sync Buildium <span className="font-bold">&quot;Listed&quot;</span>{" "}
            status with the ability to submit applications
          </>
        }
      />
    </>
  );
};
